sbAccordion = {

    el: {},

    init: function(collection){
        
        collection = collection ? collection : $('body');

        collection.find('[sb-component="Accordion"]').each(function(index, el) {
            sbAccordion.bind($(this));
        });
    },

    bind: function(accordion){

        accordion.find('> ul > li.item > a.link').unbind('click')
            .click(function(event) {

                event.preventDefault();

                var li = $(this).parent('li.item');

                if(!li.is('.expanded')){
                    sbAccordion.open(li);
                } else {
                    sbAccordion.close(li)
                }
            });
    },

    open: function(item){

        var acc = $(item).closest('[sb-component="Accordion"]');
        sbAccordion.close(acc.find('.expanded'));

        var content = $(item).find('.page-content');
        content.slideDown(500);

        $(item).addClass('expanded');

    },

    close: function(item){

        var content = $(item).find('.page-content');
        content.slideUp(500);

        $(item).removeClass('expanded');
    }
}